import React, { useRef, useState, useCallback, useEffect } from 'react'

import {
    Box,
    Chip
} from '@mui/material';

// import DateFilter from '@inovua/reactdatagrid-community/DateFilter'

import { useNavigate, Link } from 'react-router-dom';

import CommonBreadcumbs from '../../../../../components/common/CommonBreadcumbs'
import CommonRestricted from '../../../../../components/common/CommonRestricted';

import DataGridToolbar from '../../../../../components/common/DataGridToolbar';
import DataGridTable from '../../../../../components/common/DataGridTable';
// import DataGridRowActionMenu from '../../../../../components/common/DataGridRowActionMenu';
import { useAppContextFeatures } from '../../../../../context/AppContext';

import { icons } from '../../../../../components/common/CommonIcons';
import { useDataGridParams, dataGridFilterTypes } from '../../../../../hooks/useDataGridParams';
import { useSystemPrompt } from '../../../../../hooks/useSystemPrompt';
import { useSystemRoutes, routeTypes } from '../../../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../../../hooks/usePermissions";
import { useTranslations } from "../../../../../hooks/useTranslations";

import {
    containerInjectionFields,
    useContainer,
    containerTypes,
} from "../../../hooks/model/useContainer"

import { useProduct, productInjectionFields, productInjectionProps } from '../../../hooks/model/useProduct';

import styles from '../../../styles/datagrid.module.css'

const RenderDataGridTable = ({
    gridRef,
    columns,
    refreshDataGrid,
    fetchData,
    isPermissionAllow,
    filterValues,
    onSelectionChange
}) => {

    return (
        <DataGridTable
            ref={gridRef}
            refresh={refreshDataGrid}
            fetchData={fetchData}
            dataGrid={{
                idProperty: "id",
                style: {
                    minHeight: 600
                },
                pageSizes: [20, 50, 100],
                defaultLimit: 10,
                defaultSkip: 0,
                checkboxColumn:
                    isPermissionAllow({ functionType: functionTypes.remove.id }),
                columns,
                defaultFilterValue: filterValues,
                onSelectionChange,
                className: styles.dataGridCell
            }}

        />
    )

}

const RenderToolbar = ({ t, isPermissionAllow, functionTypes, handleDelete, onClickNewContainer, selectedIds }) => {

    const getToolbarMainMenus = () => {

        let props = [];

        if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
            props.push({
                displayIconName: icons.plus,
                displayText: t('newContainer'),
                onClick: onClickNewContainer
            })

            // adding the new button
            // props.push({
            //     displayIconName: icons.documents,
            //     displayText: t('importPackingExcel'),
            //     onClick: () => {

            //         navigate(getRoute("repositories/container/importPackingExcel"));

            //     }
            // })

            return props
        }

        return props
    }

    const getActionOnClick = () => {

        let handleFunction = null

        if (isPermissionAllow({ functionType: functionTypes.remove.id })) {
            handleFunction = handleDelete
        }

        return handleFunction
    }

    return (
        <DataGridToolbar
            selectedRowCount={
                selectedIds.length
            }
            mainMenus={
                getToolbarMainMenus()
            }
            actionOnClickRemove={
                getActionOnClick()
            }
            actionMenus={[]}
        />
    )
}

export default function ListContainers({
    routeType
}) {

    const { t, getTranslations } = useTranslations({ ns: ["_@repositories", "_prompt", "common", "_common"] })

    // console.log("a", getTranslations())

    const navigate = useNavigate();
    const { promptMessage } = useSystemPrompt();
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.repository.id, scopeTypes.repository.container.id)

    const { defineColumns, columns, filterValues, getRenderColumnLink, getRenderColumnBooleanDisplay, getRenderColumnTextDisplay } = useDataGridParams('id')
    const [selectedIds, setSelectedIds] = useState([])
    const { getLocationIds, setSystemLoading } = useAppContextFeatures();

    const { listContainers, deleteContainers } = useContainer({ routeType })
    const { listProducts, filterOperatorTypes } = useProduct({ routeType })

    const [refreshDataGrid, setRefreshDataGrid] = useState(0)
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)

    const gridRef = useRef();

    const resetDataGridTableSelection = () => {
        setSelectedIds([])
    }

    useEffect(() => {

        setRefreshDataGrid(val => val + 1)

    }, [getLocationIds])

    const fetchData = async (props) => {

        resetDataGridTableSelection();

        try {

            if (!props?.sortInfo) {
                props.sortInfo = {
                    id: `ax_createdatetime`,
                    dir: -1
                }
            }

            props.customFilterLocationEnable = true;
            props.customFilterLocationFields = ['location_id']

            // const result = await list(props)
            const { data, count } = await listContainers({
                props
            })

            // return {
            //     data: result?.data?.repositories,
            //     count: result?.data?.total
            // }
            return {
                data,
                count
            }

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)

            return {
                data: [],
                count: 0
            }
        }
    }

    useEffect(() => {
        defineColumnsView()
    }, [])

    const defineColumnsView = () => {
        defineColumns([
            {
                name: 'location_name',
                header: t('location'),
                defaultFlex: 0,
                defaultWidth: 70,
                renderValue: ({ value, cellProps }) => {

                    if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) === false) {
                        return getRenderColumnTextDisplay(value)
                    }

                    let path = getRoute(`repositories/container/modify/${cellProps.data.id}`);

                    return getRenderColumnLink(path, value)

                }
            },
            {
                name: 'to_location_name',
                header: t('destination'),
                defaultFlex: 0,
                defaultWidth: 80,
            },
            {
                name: 'repo_number',
                header: t('containerNo'),
                defaultFlex: 0,
                defaultWidth: 150,
                renderValue: ({ value, cellProps }) => {

                    if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) === false) {
                        return getRenderColumnTextDisplay(value)
                    }

                    let path = getRoute(`repositories/container/modify/${cellProps.data.id}`);

                    return getRenderColumnLink(path, value)
                }
            },
            {
                name: containerInjectionFields.containerType.retrieveKey,
                header: t('containerType'),
                defaultWidth: 140,
                textAlign: "center",
                renderValue: ({ value, cellProps }) => {

                    let _value = ''

                    if (value === containerTypes.mixedLCL.display) {
                        _value = containerTypes.mixedLCL.id
                    }

                    if (value === containerTypes.fullFCL.display) {
                        _value = containerTypes.fullFCL.id
                    }

                    if (value === containerTypes.shipLCL.display) {
                        _value = containerTypes.shipLCL.id
                    }

                    return (
                        <Chip
                            color='primary'
                            variant={'outlined'}
                            label={`${t(_value)}`}
                            size='small'
                        />
                    )

                },
                filter: {
                    type: dataGridFilterTypes.select,
                    props: {
                        placeholder: 'Any',
                        dataSource: [
                            {
                                id: containerTypes.mixedLCL.display,
                                label: t(containerTypes.mixedLCL.id)
                            },
                            {
                                id: containerTypes.fullFCL.display,
                                label: t(containerTypes.fullFCL.id)
                            },
                            {
                                id: containerTypes.shipLCL.display,
                                label: t(containerTypes.shipLCL.id)
                            },
                        ]
                    }
                }
            },
            {
                name: 'number_marking',
                header: t('repositoryMarking'),
                defaultFlex: 0,
                defaultWidth: 280,
            },
            // {
            //     name: 'number_alternative', header: t('secondaryNo')
            // },
            {
                name: 'number_seal',
                header: t('sealNo'),
                defaultFlex: 0,
                defaultWidth: 150,
            },
            // {
            //     name: 'number_marking', header: 'Marking'
            // },
            {
                name: 'load_date', header: t('loadDate')
            },
            {
                name: `${containerInjectionFields.totalPackQty.retrieveKey}`,
                header: t('totalPackQty'),
                textAlign: "right",
                defaultFlex: 0,
                defaultWidth: 90,
                renderValue: ({ value, cellProps }) => {

                    return parseFloat(value)

                }
            },
            {
                name: `${containerInjectionFields.totalCbm.retrieveKey}`,
                header: t('totalCbm'),
                textAlign: "right",
            },
            {
                name: `${containerInjectionFields.totalWeight.retrieveKey}`,
                header: t('totalWeight'),
                textAlign: "right",
            },
            {
                name: `${containerInjectionFields.totalValue.retrieveKey}`,
                header: t('totalValues'),
                textAlign: "right",
            },
        ])
    }

    const handleDelete = async () => {

        setSystemLoading(true)

        try {

            // have to check the container have assigned products - if have block
            // let allRelatedProducts = await fetchProductsByContainerIds({ containerIds: selectedIds })

            // console.log('allRelatedProducts', allRelatedProducts)

            // let canProceed = true
            // // let msg = ''

            // // loop for all containers to check if selected have products assigned
            // selectedIds.forEach(i => {
            //     let checkExists = allRelatedProducts.filter(i2 => i2[productInjectionProps.loadContainerId.retrieveKey] === i)

            //     if (checkExists.length > 0) {
            //         canProceed = false
            //         // msg = `${msg}}`
            //     }
            // })

            // if (canProceed === false) {
            //     promptMessage(false, t('thereAreSomeProductsAlreadyLoadedToTheContainers'))
            //     setSystemLoading(false)
            //     return false
            // }

            // let result = await remove({ ids: selectedIds })

            let result = await deleteContainers({ ids: selectedIds })

            promptMessage(true, result?.message)

            setRefreshDataGrid(currentVal => currentVal + 1)


        } catch (error) {
            promptMessage(false, t(error?.message))
        }


        setSystemLoading(false)

        return true
    }


    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.containers })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t('containers')}
                breadcrumbs={[
                    {
                        displayText: `${t('containers')} (*)`,
                        props: {
                            // underline: "hover",
                        }
                    }
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageList.id }) ?
                    <>
                        {/* {
                            RenderToolbar()
                        } */}
                        <RenderToolbar
                            t={t}
                            isPermissionAllow={isPermissionAllow}
                            selectedIds={selectedIds}
                            functionTypes={functionTypes}
                            handleDelete={handleDelete}
                            onClickNewContainer={() => {
                                navigate(getRoute("repositories/container/new"));
                            }}
                        />
                        <RenderDataGridTable
                            gridRef={gridRef}
                            columns={columns}
                            refreshDataGrid={refreshDataGrid}
                            fetchData={fetchData}
                            isPermissionAllow={isPermissionAllow}
                            filterValues={filterValues}
                            onSelectionChange={(items) => {
                                // console.log('items selected : ', items)
                                setSelectedIds(
                                    items
                                )
                            }}
                        />
                        {/* {
                            RenderDataGridTable()
                        } */}
                    </>
                    :
                    (
                        <CommonRestricted />
                    )
            }

        </Box>
    )
}